export default [
  {
    text: 'С понедельника по пятницу',
    value: 'weekdays',
  },
  {
    text: 'Ежедневно',
    value: 'daily',
  },
];
